export const COUPON_STATUS = [
    {id:'active',title:'Active'},
    {id:'inactive',title:'Inactive'},
    {id:'expired',title:'Expired'},
    {id:'limit_reached',title:'Limit Reached'},
]
export const COUPON_KINDS = [
    {
        id:'non_unique',
        label:'COUPON.ADD_FORM.TYPE_FORM.TYPE.LIST.NON_UNIQUE',
        description:'COUPON.ADD_FORM.TYPE_FORM.TYPE.LIST.NON_UNIQUE_DESC'
    },
    {
        id:'unique',
        label:'COUPON.ADD_FORM.TYPE_FORM.TYPE.LIST.UNIQUE',
        description:'COUPON.ADD_FORM.TYPE_FORM.TYPE.LIST.UNIQUE_DESC'
    },
]

export const COUPON_REDEEM_LIST = [
    {
        id:'once',
        title: 'COUPON.ADD_FORM.TYPE_FORM.DURATION.LIST.ONCE',
    },
    {
        id:'forever',
        title: 'COUPON.ADD_FORM.TYPE_FORM.DURATION.LIST.FOREVER',
    },
    {
        id:'multiple_month',
        title: 'COUPON.ADD_FORM.TYPE_FORM.DURATION.LIST.MULTIPLE_MONTH',
    },
]